import axios from '../../utils/axios'
import { API_BASE_URL } from '../../constants'

export const createReport = async (fileId, sampleName, selectedVariants, selectedRows) => {
  return await axios.post(`${API_BASE_URL}/create-report/${fileId}/${sampleName}`, {
    fileId: fileId,
    sampleName: sampleName,
    selectedVariants: selectedVariants,
    selectedRows: selectedRows,
  })
}

export const checkReport = async (fileId, type = 'vcf') => {
  return await axios.get(`${API_BASE_URL}/vcf/check-report/${fileId}/${type}`)
}

export const downloadReport = async (fileId, type = 'vcf') => {
  return await axios.get(`${API_BASE_URL}/vcf/download-report/${fileId}`, {
    responseType: 'blob',
  })
}
